import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "segment-content" }
const _hoisted_2 = { class: "text-block left" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "text-block right" }
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "search-result-item",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select', _ctx.result)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          class: "text",
          innerHTML: _ctx.highlightedSource
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          class: "text",
          innerHTML: _ctx.highlightedTarget
        }, null, 8, _hoisted_5)
      ])
    ])
  ]))
}